<template>
  <div class="relative flex-1 flex flex-col justify-between md:hidden">
    <Transition
      appear
      enter-active-class="transition duration-300"
      enter-from-class="translate-x-1/2 opacity-0"
    >
      <nav class="flex flex-col flex-1 bg-gray-50 py-6">
        <MobileLanguagesMenu
          :alternate-languages="alternateLanguages"
          @toggle="langPanelOpen = $event"
        />
        <button
          v-if="!noSearch"
          class="flex items-center px-4 h-12 bg-white rounded-6 mx-8 mb-4"
          @click="$emit('click-search')"
          @mouseenter="$emit('over-search')"
          @mouseleave="$emit('leave-search')"
        >
          <svg role="presentation" focusable="false" tabindex="-1" class="icon icon-md mr-2"   alt="" svg-inline  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16.04 15.86a1 1 0 0 0-.18.18 6.97 6.97 0 0 1-9.81-.09 6.98 6.98 0 0 1 0-9.9 6.98 6.98 0 0 1 9.9 0 6.98 6.98 0 0 1 .1 9.8zm5.67 4.43-3.68-3.67a8.97 8.97 0 0 0-.67-11.98 8.97 8.97 0 0 0-12.72 0 8.97 8.97 0 0 0 0 12.72 8.97 8.97 0 0 0 11.98.67l3.67 3.68a1 1 0 1 0 1.42-1.42z"/></svg>
          <span class="truncate text-16 font-medium text-gray-500">{{
            $t('header.search_placeholder')
          }}</span>
        </button>
        <ul v-if="!langPanelOpen" class="list-none">
          <MenuContent
            v-for="item in navigation"
            :key="item.id"
            :id="item.id"
            :link="item.link"
            :items="item.items"
            :highlights="item.highlights"
            :sub-label-mobile="item.subLabelMobile"
          />
        </ul>
      </nav>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import type { GQLNavigationItem } from './generated/page-header'
import type { AlternateLanguage } from './types'
import MobileLanguagesMenu from './mobile-languages-menu.vue'
import MenuContent from './menu-content.vue'

defineProps<{
  navigation: GQLNavigationItem[]
  alternateLanguages: AlternateLanguage[]
  noSearch?: boolean
}>()

defineEmits(['over-search', 'click-search', 'leave-search'])

const langPanelOpen = ref(false)
</script>
